<h1>Connexion</h1>

<div class="row justify-content-center">
    <div class="col col-md-6 col-xl-4 ">
        <form class="container-fluid" [formGroup]="signInForm" (ngSubmit)="onSubmit()">
            <div class="mb-3">
                <label for="emailSignIn" class="form-label">Email</label>
                <input type="email" class="form-control" id="emailSignIn" aria-describedby="emailHelp" 
                    formControlName="email" 
                    (blur)="testEmail()" 
                    [ngClass]="{'is-valid': isEmailFormatValid, 'is-invalid': isEmailFormatInvalid}">
                <div id="validationEmailFormat" class="invalid-feedback">
                    L'email semble incorect
                </div>
            </div>
            <div class="mb-3">
                <label for="passwordSignIn" class="form-label">Mot de passe</label>
                <input type="password" class="form-control" id="passwordSignIn" 
                    formControlName="password" 
                    (blur)="testPassword()" 
                    [ngClass]="{'is-valid': isPasswordLengthValid, 'is-invalid': isPasswordLengthInvalid}">
                <div id="validationLengthPassword" class="invalid-feedback">
                    Mot de passe trop court
                </div>
            </div>
            <button type="submit" class="btn" [disabled]="signInForm.invalid">Se connecter</button>
        </form>
    </div>
</div>

<p class="messageError">{{ errorMessage }}</p>
